import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, OnInit, QueryList, ViewChildren } from '@angular/core';
import { environment } from '../../../environments/environment';
import { CommonService } from '../../../app/core/services/common.service';
import { SeoService } from '../../../app/core/services/seo.service';
import { Router } from '@angular/router';
import { SharedService } from '../../../app/core/services/shared.service';
import { DomSanitizer, Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-client-page',
  templateUrl: './client-page.component.html',
  styleUrls: ['./client-page.component.scss']
})
export class ClientPageComponent implements OnInit, AfterViewInit {

   constructor( public router:Router,private seo : SeoService ,private titleService:Title,private translate : TranslateService,
      public commonService: CommonService, private cdr: ChangeDetectorRef, private sharedService : SharedService, private sanitizer: DomSanitizer) {
        
      }
  
  appsUrl = environment.CMS_APPS_URL;
  signUrl = environment.WEB_URL;
  languageCode: string = "en";

  rating1 = 4.8;
  rating2 = 4.5;
  rating3 = 5.0;

  ngOnInit(): void {
    this.getTemplates();
  }

  templates = [];

  public getTemplates(){
  
    let templatesList = this.commonService.templates;
    this.templates = templatesList;
    this.triggerChange();
  }

  getSafeIcon(icon: string) {
    return this.sanitizer.bypassSecurityTrustHtml(icon);
  }  

  expandedIndex = 0;
  faqAccordion = [
    {
        "sectionTitle": "General Questions About Amy",
        "questions": [
            {
                "question": "What is Amy Marketplace?",
                "answer": "Amy Marketplace is a platform for hiring contract talent from agencies or outsourcing sprints to agencies around the world."
              },
              {
                "question": "How does Amy Marketplace work for hiring companies?",
                "answer": "Amy simplifies the process of discovering agencies, comparing costs, and managing projects seamlessly within the platform. From \"Ask Amy\" you can hire contract talent from agencies and use \"Task manager\" to outsource sprints to agencies."
              },
              {
                "question": "Is Amy free for hiring companies?",
                "answer": "Yes, hiring companies can use Amy for free. We charge service providers a platform fee."
              },
              {
                "question": "Who are the agencies listed on Amy?",
                "answer": "Companies around the world who are in the services business offer their teams on Amy. We call them agencies. Agencies on Amy are vetted and publish their teams with details like location, skills, experience, and availability so you can try for a week or hire them instantly for your contract positions."
              }              
        ]
    },
    {
        "sectionTitle": "Finding and Hiring Agencies",
        "questions": [
            {
                "question": "How do I find the right agency for my project?",
                "answer": "You can use \"Cost compare\" feature list on sprint. You can find the right agency by browsing through the list of vetted agencies on Amy. Use filters to narrow down your search based on location, skills, experience, availability and other filters and invite agencies you like to share your project details with them."
            },
            {
                "question": "Can I contact multiple agencies before making a decision?",
                "answer": "Yes, you can reach out to multiple agencies to discuss your project requirements and get quotes before making a final decision."
            },
            {
                "question": "What should I consider when hiring an agency?",
                "answer": "Consider factors such as the agency's portfolio, client reviews, communication style, and pricing structure when hiring an agency."
            }
        ]
    },
    {
        "sectionTitle": "Cost and Payment",
        "questions": [
            {
                "question": "How are payments handled on Amy?",
                "answer": "Payments are handled securely through the platform. You can choose from various payment options, including credit cards and bank transfers."
            },
            {
                "question": "Are there any additional fees for using Amy?",
                "answer": "Hiring companies can use Amy for free. However, service providers are charged a platform fee."
            },
            {
                "question": "What if I am not satisfied with the work delivered?",
                "answer": "If you are not satisfied with the work delivered, you can contact Amy's support team for assistance. They will work with you to resolve the issue."
            }
        ]
    },
    {
        "sectionTitle": "Legal and Contractual",
        "questions": [
            {
                "question": "What kind of contracts are used on Amy?",
                "answer": "Amy provides standard contract templates that you can use when hiring an agency. These contracts cover essential terms and conditions."
            },
            {
                "question": "How are disputes resolved on Amy?",
                "answer": "Disputes are resolved through Amy's dispute resolution process. Both parties can submit evidence, and a neutral third party will make a decision."
            },
            {
                "question": "What are the legal protections for hiring companies?",
                "answer": "Hiring companies are protected by the terms and conditions outlined in the contract. Since companies for first 3 payments pay advance on the platform and release the amount only after the work is completed so payments handled via the platform are safe. You are not advised to make payments outside the platform for your safety."
            }
        ]
    },
    {
        "sectionTitle": "Comparison with Freelancers",
        "questions": [
            {
                "question": "What are the benefits of hiring an agency over a freelancer?",
                "answer": "Hiring an agency can provide more resources, expertise, and reliability compared to a single freelancer. Agencies often have a team of specialists who can handle various aspects of your project."
            },
            {
                "question": "Are agencies more expensive than freelancers?",
                "answer": "In our experience, there are all kinds of agencies that charge more and less compared to a freelancer. You need to choose as per the geography, price point you prefer, for example - Agencies from India, Philippines and other Asian countries charge less than or equivalent costs to freelancers from US, Europe or UK. If you are price sensitive you can work with such Agencies."
            },
            {
                "question": "Can I hire both agencies and freelancers on Amy?",
                "answer": "No, Amy is only for hiring talent from various agencies around the world. Amy does not entertain freelancers on our platform."
            }
        ]
    },
    {
        "sectionTitle": "Using Amy Marketplace",
        "questions": [
            {
                "question": "How do I get started on Amy Marketplace?",
                "answer": "To get started, create an account on Amy.pro, set up your profile, and start browsing agencies. You can also post a project to receive proposals from agencies."
            },
            {
                "question": "Can I manage multiple projects on Amy?",
                "answer": "Yes, you can manage multiple projects on Amy. The platform provides tools to track progress, communicate with agencies, and handle payments for each project."
            },
            {
                "question": "What if I need help using the platform?",
                "answer": "If you need help using the platform, you can contact Amy's support team for assistance. They are available to answer your questions and provide guidance. Additionally you can visit FAQ section of our website to find most common questions that most people might have asked us before."
            }
        ]
    },
    {
        "sectionTitle": "Security and Privacy",
        "questions": [
            {
                "question": "How does Amy protect my data?",
                "answer": "Amy uses advanced security measures to protect your data, including encryption and secure servers. Your information is kept confidential and is not shared with third parties without your consent."
            },
            {
                "question": "What happens if there is a data breach?",
                "answer": "In the event of a data breach, Amy will notify you immediately and take steps to secure your information. They will also provide guidance on what actions you should take."
            },
            {
                "question": "Can I control who sees my project details?",
                "answer": "Yes, you can control who sees your project details by adjusting your privacy settings. You can choose to make your project visible to all agencies or only to selected agencies."
            }
        ]
    },
    {
        "sectionTitle": "Feedback and Support",
        "questions": [
            {
                "question": "How do I provide feedback on an agency?",
                "answer": "You can provide feedback on an agency by leaving a review on their profile. This helps other hiring companies make informed decisions."
            },
            {
                "question": "What if I have a complaint about an agency?",
                "answer": "If you have a complaint about an agency, you can contact Amy's support team. They will investigate the issue and take appropriate action."
            },
            {
                "question": "How can I get support on Amy?",
                "answer": "You can get support on Amy by contacting their support team through the platform. They are available to assist you with any questions or issues you may have."
            }
        ]
    }
]

  togglePanel(index: number): void {
    this.expandedIndex = this.expandedIndex === index ? null : index;
  }

   @ViewChildren('contentWrapper') contentWrappers!: QueryList<ElementRef>;
    contentHeights: number[] = [];
  
    ngAfterViewInit(): void {
      // Store the heights of all content wrappers
      this.contentHeights = this.contentWrappers.map(
        (wrapper) => wrapper.nativeElement.scrollHeight
      );
    }
  

  
  // trigger the changes
  public triggerChange() {
    if (!this.cdr['destroyed']) {
      this.cdr.detectChanges();
    }
  }
}
